import {PlainDtoModel} from "../../../../../common/entity/dto/plain/plainDto.model";
import {CamMachineSummaryModel} from "../../../../../3d/cam/machine/api/model/camMachineSummary.model";
import {
    ProviderServiceOptionSummaryModel
} from "../../../../../provider/service/option/api/entity/providerServiceOptionSummary.model";

export class InsolesProviderModelCamMachineModel implements PlainDtoModel{
    id: number;
    camMachine: CamMachineSummaryModel;
    useByDefault: boolean;
    addNumber: boolean;
    config: string;
    overrideCoreConfig: boolean;
    options: ProviderServiceOptionSummaryModel[] = [];
}